module.exports = __webpack_public_path__ + "static/img/2.4a952ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/User/2.png
// module id = ghB9
// module chunks = 0